import callPersonnelApi from './personnelService';
import callBackendApi from '../backendService/backendService';
import { buildQueryUrlFromObject } from '../../helper/buildQueryUrlFromObject';

const basePath = `/frontend/api/one-to-one/${process.env.VUE_APP_COMPANY_KEY}`;

// 取得Event活動專賣店
export const getEventActivityReservationEditData = (formData) => callPersonnelApi({
    method: 'GET',
    endpoint: `${basePath}/activity/reservation/${formData}`,
    body: formData
});

export const updateEventActivityReservation = (formData) => callPersonnelApi({
    method: 'PUT',
    endpoint: `${basePath}/activity/reservation/sp/${formData.id}`,
    body: formData
});
